export default {
    init: function () {
        let paidAdParam = new URLSearchParams(document.location.search.substring(1)).get('UTM_medium'),
            paidAdLower = new URLSearchParams(document.location.search.substring(1)).get('utm_medium');
        if (paidAdParam !== 'sem' && paidAdLower !== 'sem') return;
        // check for bypass param
        let skyboxBypassParam = new URLSearchParams(document.location.search.substring(1)).get('skyboxer');
        let linkedInBypassParam = new URLSearchParams(document.location.search.substring(1)).get('linkedin_forms');
        if (skyboxBypassParam === 'true' || linkedInBypassParam === 'valid') $('body').addClass('marketo-success');
        this.bindEvents();
    },

    addQueryParam: function ($$, param) {
        $($$).attr('href', function (i, href) {
            return href + param;
        });
    },

    bindEvents: function () {
        let _this = this;

        // Add Param if user navigates to the home page
        $('.brand').on('click', function () {
            _this.addQueryParam(this, '?paidad=home');
        });

        // Add Param if user navigates to privacy policy or terms and conditions
        $('.footer-bottom-links a').on('click', function (e) {
            let hrefVal = $(this).attr('href');
            if (hrefVal.indexOf('privacy-policy') >= 0) {
                _this.addQueryParam(this, '?paidad=privacy-policy');
            }
            if (hrefVal.indexOf('terms') >= 0) {
                _this.addQueryParam(this, '?paidad=terms-and-conditions');
            }

        });

    },

};
